export interface RestaurantMenuItem {
  name: string;
  explanation: string;
  acneImpactScore: number;
  restaurantName: string;
  cuisine?: string;
}

// Cheesecake Factory menu items
const CHEESECAKE_FACTORY_MENU: RestaurantMenuItem[] = [
  {
    name: 'SkinnyLicious Grilled Chicken',
    explanation: 'Grilled chicken breast with vegetables. Lower in oil and refined carbs, better for skin health.',
    acneImpactScore: 38,
    restaurantName: 'The Cheesecake Factory',
  },
  {
    name: 'Grilled Salmon with Vegetables',
    explanation: 'Grilled salmon fillet with steamed vegetables. High in omega-3s, no deep-frying, excellent for skin.',
    acneImpactScore: 35,
    restaurantName: 'The Cheesecake Factory',
  },
  {
    name: 'SkinnyLicious House Salad',
    explanation: 'Fresh greens with vegetables and light dressing. High in fiber, low in refined carbs and dairy.',
    acneImpactScore: 32,
    restaurantName: 'The Cheesecake Factory',
  },
  {
    name: 'SkinnyLicious Grilled Turkey Burger',
    explanation: 'Grilled turkey burger with vegetables. Lower in processed fats than beef burgers.',
    acneImpactScore: 40,
    restaurantName: 'The Cheesecake Factory',
  },
  {
    name: 'Grilled Chicken and Avocado Club',
    explanation: 'Grilled chicken with avocado and vegetables. Lower in dairy and processed fats.',
    acneImpactScore: 42,
    restaurantName: 'The Cheesecake Factory',
  },
  {
    name: 'SkinnyLicious Grilled Chicken Pasta',
    explanation: 'Grilled chicken with pasta and light sauce. Lower in dairy than creamy pasta dishes.',
    acneImpactScore: 45,
    restaurantName: 'The Cheesecake Factory',
  },
  {
    name: 'Grilled Steak with Vegetables',
    explanation: 'Grilled steak with steamed vegetables. Lower in oil than fried items.',
    acneImpactScore: 42,
    restaurantName: 'The Cheesecake Factory',
  },
];

// McDonald's menu items
const MCDONALDS_MENU: RestaurantMenuItem[] = [
  {
    name: 'Grilled Chicken Sandwich',
    explanation: 'Grilled chicken sandwich instead of fried. Much lower in processed fats and oil.',
    acneImpactScore: 42,
    restaurantName: 'McDonald\'s',
  },
  {
    name: 'Grilled Chicken Salad',
    explanation: 'Salad with grilled chicken. Much lower in refined carbs and processed fats than burgers and fries.',
    acneImpactScore: 35,
    restaurantName: 'McDonald\'s',
  },
  {
    name: 'Egg White Delight McMuffin',
    explanation: 'Egg white sandwich with lean protein. Lower in saturated fat than regular breakfast items.',
    acneImpactScore: 40,
    restaurantName: 'McDonald\'s',
  },
  {
    name: 'Fruit and Maple Oatmeal',
    explanation: 'Oatmeal with fruit. High in fiber, lower in refined carbs and sugar than other breakfast options.',
    acneImpactScore: 38,
    restaurantName: 'McDonald\'s',
  },
  {
    name: 'Apple Slices',
    explanation: 'Fresh fruit. High in fiber, no processed ingredients, excellent for skin health.',
    acneImpactScore: 25,
    restaurantName: 'McDonald\'s',
  },
];

// Dunkin' Donuts menu items
const DUNKIN_DONUTS_MENU: RestaurantMenuItem[] = [
  {
    name: 'Egg White Veggie Wake-Up Wrap',
    explanation: 'Egg white wrap with vegetables. Lower in refined carbs and saturated fat than donuts.',
    acneImpactScore: 38,
    restaurantName: 'Dunkin\' Donuts',
  },
  {
    name: 'Turkey Sausage Wake-Up Wrap',
    explanation: 'Turkey sausage wrap. Lower in processed fats than pork sausage options.',
    acneImpactScore: 40,
    restaurantName: 'Dunkin\' Donuts',
  },
  {
    name: 'Oatmeal with Fruit',
    explanation: 'Oatmeal with fruit toppings. High in fiber, lower in refined carbs and sugar.',
    acneImpactScore: 35,
    restaurantName: 'Dunkin\' Donuts',
  },
  {
    name: 'Grilled Chicken Sandwich',
    explanation: 'Grilled chicken sandwich. Lower in processed fats than fried options.',
    acneImpactScore: 42,
    restaurantName: 'Dunkin\' Donuts',
  },
  {
    name: 'Hash Browns (Small Portion)',
    explanation: 'Small portion of hash browns. Lower in refined carbs than donuts or pastries.',
    acneImpactScore: 48,
    restaurantName: 'Dunkin\' Donuts',
  },
];

// Wendy's menu items
const WENDYS_MENU: RestaurantMenuItem[] = [
  {
    name: 'Grilled Chicken Sandwich',
    explanation: 'Grilled chicken sandwich instead of fried. Much lower in processed fats and oil.',
    acneImpactScore: 42,
    restaurantName: 'Wendy\'s',
  },
  {
    name: 'Grilled Chicken Wrap',
    explanation: 'Wrap with grilled chicken and vegetables. Lower in refined carbs and processed fats.',
    acneImpactScore: 40,
    restaurantName: 'Wendy\'s',
  },
  {
    name: 'Apple Pecan Chicken Salad',
    explanation: 'Salad with grilled chicken, apples, and pecans. High in fiber, lower in refined carbs.',
    acneImpactScore: 35,
    restaurantName: 'Wendy\'s',
  },
  {
    name: 'Grilled Chicken Caesar Salad',
    explanation: 'Caesar salad with grilled chicken. Lower in refined carbs than burgers and fries.',
    acneImpactScore: 38,
    restaurantName: 'Wendy\'s',
  },
  {
    name: 'Baked Potato',
    explanation: 'Baked potato with vegetables. High in fiber, lower in processed fats than fries.',
    acneImpactScore: 38,
    restaurantName: 'Wendy\'s',
  },
];

// Burger King menu items
const BURGER_KING_MENU: RestaurantMenuItem[] = [
  {
    name: 'Grilled Chicken Sandwich',
    explanation: 'Grilled chicken sandwich instead of fried. Much lower in processed fats and oil.',
    acneImpactScore: 42,
    restaurantName: 'Burger King',
  },
  {
    name: 'Grilled Chicken Garden Salad',
    explanation: 'Salad with grilled chicken and vegetables. Much lower in refined carbs and processed fats.',
    acneImpactScore: 35,
    restaurantName: 'Burger King',
  },
  {
    name: 'Grilled Chicken Wrap',
    explanation: 'Wrap with grilled chicken and vegetables. Lower in refined carbs than burgers.',
    acneImpactScore: 40,
    restaurantName: 'Burger King',
  },
  {
    name: 'Side Garden Salad',
    explanation: 'Fresh garden salad. High in fiber, no processed ingredients.',
    acneImpactScore: 30,
    restaurantName: 'Burger King',
  },
];

// Subway menu items
const SUBWAY_MENU: RestaurantMenuItem[] = [
  {
    name: 'Grilled Chicken Salad',
    explanation: 'Salad with grilled chicken and vegetables. Lower in refined carbs than sandwiches.',
    acneImpactScore: 35,
    restaurantName: 'Subway',
  },
  {
    name: 'Grilled Chicken Sandwich (6 inch, whole wheat)',
    explanation: 'Grilled chicken on whole wheat bread with vegetables. Lower in refined carbs and processed fats.',
    acneImpactScore: 40,
    restaurantName: 'Subway',
  },
  {
    name: 'Turkey Breast Sandwich (6 inch, whole wheat)',
    explanation: 'Turkey breast on whole wheat with vegetables. Lower in processed fats than other meats.',
    acneImpactScore: 38,
    restaurantName: 'Subway',
  },
  {
    name: 'Veggie Delite Salad',
    explanation: 'Fresh vegetables and greens. High in fiber, no processed ingredients.',
    acneImpactScore: 28,
    restaurantName: 'Subway',
  },
  {
    name: 'Oven Roasted Chicken Sandwich (6 inch, whole wheat)',
    explanation: 'Oven roasted chicken on whole wheat with vegetables. Lower in processed fats.',
    acneImpactScore: 40,
    restaurantName: 'Subway',
  },
];

// KFC menu items
const KFC_MENU: RestaurantMenuItem[] = [
  {
    name: 'Grilled Chicken',
    explanation: 'Grilled chicken instead of fried. Much lower in oil and processed fats.',
    acneImpactScore: 40,
    restaurantName: 'KFC',
  },
  {
    name: 'Grilled Chicken Sandwich',
    explanation: 'Grilled chicken sandwich. Lower in processed fats than fried chicken.',
    acneImpactScore: 42,
    restaurantName: 'KFC',
  },
  {
    name: 'Grilled Chicken Salad',
    explanation: 'Salad with grilled chicken. Much lower in refined carbs and processed fats.',
    acneImpactScore: 35,
    restaurantName: 'KFC',
  },
  {
    name: 'Green Beans',
    explanation: 'Steamed green beans. High in fiber, no processed ingredients.',
    acneImpactScore: 25,
    restaurantName: 'KFC',
  },
  {
    name: 'Corn on the Cob',
    explanation: 'Corn on the cob. High in fiber, lower in processed ingredients than sides.',
    acneImpactScore: 30,
    restaurantName: 'KFC',
  },
];

// Taco Bell menu items
const TACO_BELL_MENU: RestaurantMenuItem[] = [
  {
    name: 'Grilled Chicken Soft Taco',
    explanation: 'Soft taco with grilled chicken and vegetables. Skip cheese and sour cream. Lower in dairy and processed fats.',
    acneImpactScore: 42,
    restaurantName: 'Taco Bell',
  },
  {
    name: 'Grilled Chicken Burrito Bowl',
    explanation: 'Burrito bowl with grilled chicken, rice, beans, and vegetables. Skip cheese and sour cream.',
    acneImpactScore: 40,
    restaurantName: 'Taco Bell',
  },
  {
    name: 'Grilled Chicken Power Bowl',
    explanation: 'Power bowl with grilled chicken, vegetables, and rice. Lower in refined carbs and dairy.',
    acneImpactScore: 38,
    restaurantName: 'Taco Bell',
  },
  {
    name: 'Black Bean Burrito (Fresco Style)',
    explanation: 'Black bean burrito with vegetables, fresco style (no cheese/sour cream). High in fiber, lower in dairy.',
    acneImpactScore: 40,
    restaurantName: 'Taco Bell',
  },
];

// Chipotle menu items
const CHIPOTLE_MENU: RestaurantMenuItem[] = [
  {
    name: 'Grilled Chicken Burrito Bowl',
    explanation: 'Burrito bowl with grilled chicken, rice, beans, and vegetables. Skip cheese and sour cream.',
    acneImpactScore: 40,
    restaurantName: 'Chipotle',
  },
  {
    name: 'Grilled Chicken Salad Bowl',
    explanation: 'Salad bowl with grilled chicken and vegetables. Much lower in refined carbs and dairy.',
    acneImpactScore: 35,
    restaurantName: 'Chipotle',
  },
  {
    name: 'Grilled Chicken Soft Tacos',
    explanation: 'Soft tacos with grilled chicken and vegetables. Skip cheese and sour cream.',
    acneImpactScore: 42,
    restaurantName: 'Chipotle',
  },
  {
    name: 'Grilled Steak Bowl',
    explanation: 'Bowl with grilled steak, rice, beans, and vegetables. Skip cheese and sour cream.',
    acneImpactScore: 45,
    restaurantName: 'Chipotle',
  },
  {
    name: 'Sofritas Bowl',
    explanation: 'Bowl with sofritas (tofu), rice, beans, and vegetables. High in protein, lower in dairy.',
    acneImpactScore: 38,
    restaurantName: 'Chipotle',
  },
];

// Olive Garden menu items
const OLIVE_GARDEN_MENU: RestaurantMenuItem[] = [
  {
    name: 'Grilled Chicken with Vegetables',
    explanation: 'Grilled chicken with roasted vegetables. Much lower in dairy and refined carbs than creamy pasta.',
    acneImpactScore: 38,
    restaurantName: 'Olive Garden',
  },
  {
    name: 'Grilled Salmon with Vegetables',
    explanation: 'Grilled salmon with vegetables. High in omega-3s, no dairy, better for skin.',
    acneImpactScore: 35,
    restaurantName: 'Olive Garden',
  },
  {
    name: 'Herb-Grilled Salmon',
    explanation: 'Herb-grilled salmon with vegetables. High in omega-3s, lower in dairy and refined carbs.',
    acneImpactScore: 35,
    restaurantName: 'Olive Garden',
  },
  {
    name: 'Marinara Pasta with Grilled Chicken',
    explanation: 'Tomato-based pasta with grilled chicken. Lower in dairy than creamy sauces.',
    acneImpactScore: 45,
    restaurantName: 'Olive Garden',
  },
  {
    name: 'Garden Fresh Salad',
    explanation: 'Fresh garden salad with light dressing. High in fiber, lower in refined carbs and dairy.',
    acneImpactScore: 32,
    restaurantName: 'Olive Garden',
  },
];

// Applebee's menu items
const APPLEBEES_MENU: RestaurantMenuItem[] = [
  {
    name: 'Grilled Chicken Breast',
    explanation: 'Grilled chicken breast with vegetables. Lower in oil and refined carbs than fried items.',
    acneImpactScore: 38,
    restaurantName: 'Applebee\'s',
  },
  {
    name: 'Grilled Salmon',
    explanation: 'Grilled salmon with vegetables. High in omega-3s, no deep-frying, better for skin.',
    acneImpactScore: 35,
    restaurantName: 'Applebee\'s',
  },
  {
    name: 'Grilled Chicken Caesar Salad',
    explanation: 'Caesar salad with grilled chicken. Lower in refined carbs than burgers and fries.',
    acneImpactScore: 38,
    restaurantName: 'Applebee\'s',
  },
  {
    name: 'Grilled Chicken and Shrimp',
    explanation: 'Grilled chicken and shrimp with vegetables. Lower in processed fats than fried items.',
    acneImpactScore: 40,
    restaurantName: 'Applebee\'s',
  },
];

// Outback Steakhouse menu items
const OUTBACK_MENU: RestaurantMenuItem[] = [
  {
    name: 'Grilled Chicken on the Barbie',
    explanation: 'Grilled chicken with vegetables. Lower in oil and processed fats than fried items.',
    acneImpactScore: 38,
    restaurantName: 'Outback Steakhouse',
  },
  {
    name: 'Grilled Salmon',
    explanation: 'Grilled salmon with vegetables. High in omega-3s, no deep-frying, excellent for skin.',
    acneImpactScore: 35,
    restaurantName: 'Outback Steakhouse',
  },
  {
    name: 'Grilled Chicken Caesar Salad',
    explanation: 'Caesar salad with grilled chicken. Lower in refined carbs than burgers and fries.',
    acneImpactScore: 38,
    restaurantName: 'Outback Steakhouse',
  },
  {
    name: 'Grilled Shrimp on the Barbie',
    explanation: 'Grilled shrimp with vegetables. Lower in processed fats than fried items.',
    acneImpactScore: 38,
    restaurantName: 'Outback Steakhouse',
  },
];

// Red Lobster menu items
const RED_LOBSTER_MENU: RestaurantMenuItem[] = [
  {
    name: 'Grilled Salmon',
    explanation: 'Grilled salmon with vegetables. High in omega-3s, no deep-frying, excellent for skin.',
    acneImpactScore: 35,
    restaurantName: 'Red Lobster',
  },
  {
    name: 'Grilled Shrimp',
    explanation: 'Grilled shrimp with vegetables. Lower in processed fats than fried items.',
    acneImpactScore: 38,
    restaurantName: 'Red Lobster',
  },
  {
    name: 'Grilled Chicken',
    explanation: 'Grilled chicken with vegetables. Lower in oil and processed fats than fried items.',
    acneImpactScore: 38,
    restaurantName: 'Red Lobster',
  },
  {
    name: 'Grilled Salmon Caesar Salad',
    explanation: 'Caesar salad with grilled salmon. High in omega-3s, lower in refined carbs.',
    acneImpactScore: 35,
    restaurantName: 'Red Lobster',
  },
];

// Panda Express menu items
const PANDA_EXPRESS_MENU: RestaurantMenuItem[] = [
  {
    name: 'Grilled Teriyaki Chicken',
    explanation: 'Grilled teriyaki chicken with steamed vegetables. Much lower in oil and sugar than fried items.',
    acneImpactScore: 42,
    restaurantName: 'Panda Express',
  },
  {
    name: 'Mixed Vegetables with Steamed Rice',
    explanation: 'Vegetable-based dish with steamed rice. Much lower in oil and sugar than fried items.',
    acneImpactScore: 35,
    restaurantName: 'Panda Express',
  },
  {
    name: 'Steamed Chicken with Broccoli',
    explanation: 'Steamed chicken with broccoli. No oil, no deep-frying, excellent for acne health.',
    acneImpactScore: 38,
    restaurantName: 'Panda Express',
  },
  {
    name: 'Steamed White Meat Chicken',
    explanation: 'Steamed white meat chicken with vegetables. Lower in oil than fried items.',
    acneImpactScore: 38,
    restaurantName: 'Panda Express',
  },
];

// Indian Restaurant menu items (generic for all Indian restaurants)
const INDIAN_RESTAURANT_MENU: RestaurantMenuItem[] = [
  {
    name: 'Dal Tadka',
    explanation: 'Lentil curry with minimal oil, tempered with spices. High in protein and fiber, lower in dairy and oil than paneer dishes.',
    acneImpactScore: 35,
    restaurantName: 'Indian Restaurant',
  },
  {
    name: 'Tandoori Chicken',
    explanation: 'Grilled chicken marinated in yogurt and spices, cooked in tandoor. No deep-frying, lower in oil and dairy than creamy curries.',
    acneImpactScore: 38,
    restaurantName: 'Indian Restaurant',
  },
  {
    name: 'Herb-grilled chicken breast',
    explanation: 'Herb-grilled chicken breast with spices. No deep-frying, lower in oil than fried chicken dishes.',
    acneImpactScore: 38,
    restaurantName: 'Indian Restaurant',
  },
  {
    name: 'Pan-seared salmon',
    explanation: 'Pan-seared salmon fillet with spices. High in omega-3s, no deep-frying, excellent for skin health.',
    acneImpactScore: 35,
    restaurantName: 'Indian Restaurant',
  },
  {
    name: 'Chana Masala',
    explanation: 'Chickpea curry with tomatoes and spices. High in fiber, lower in dairy and oil than paneer dishes.',
    acneImpactScore: 40,
    restaurantName: 'Indian Restaurant',
  },
  {
    name: 'Bhindi Masala',
    explanation: 'Okra curry with minimal oil. High in fiber, no dairy, better for skin health.',
    acneImpactScore: 32,
    restaurantName: 'Indian Restaurant',
  },
  {
    name: 'Aloo Gobi',
    explanation: 'Potato and cauliflower curry with minimal oil. High in fiber, lower in dairy than creamy dishes.',
    acneImpactScore: 38,
    restaurantName: 'Indian Restaurant',
  },
  {
    name: 'Baingan Bharta',
    explanation: 'Roasted eggplant curry. High in fiber, minimal oil, no dairy, excellent for skin health.',
    acneImpactScore: 35,
    restaurantName: 'Indian Restaurant',
  },
  {
    name: 'Rajma',
    explanation: 'Kidney bean curry with tomatoes and spices. High in protein and fiber, lower in dairy and oil.',
    acneImpactScore: 38,
    restaurantName: 'Indian Restaurant',
  },
  {
    name: 'Tandoori Roti',
    explanation: 'Whole wheat flatbread cooked in tandoor. Lower in refined carbs and oil than naan.',
    acneImpactScore: 40,
    restaurantName: 'Indian Restaurant',
  },
  {
    name: 'Mixed Vegetable Curry',
    explanation: 'Vegetable-based curry with minimal oil. High in fiber, lower in dairy and refined carbs.',
    acneImpactScore: 38,
    restaurantName: 'Indian Restaurant',
  },
  {
    name: 'Dal Makhani (Light)',
    explanation: 'Black lentil curry, request light cream. High in protein and fiber, lower in dairy than regular version.',
    acneImpactScore: 42,
    restaurantName: 'Indian Restaurant',
  },
  {
    name: 'Tandoori Fish',
    explanation: 'Grilled fish marinated in spices, cooked in tandoor. High in omega-3s, no deep-frying, excellent for skin.',
    acneImpactScore: 35,
    restaurantName: 'Indian Restaurant',
  },
  {
    name: 'Vegetable Biryani (Light)',
    explanation: 'Vegetable biryani with minimal oil. Request light oil preparation. High in fiber, lower in oil than regular biryani.',
    acneImpactScore: 42,
    restaurantName: 'Indian Restaurant',
  },
  {
    name: 'Sambar',
    explanation: 'Lentil and vegetable stew. High in protein, fiber, and antioxidants. Supports skin health.',
    acneImpactScore: 33,
    restaurantName: 'Indian Restaurant',
  },
  {
    name: 'Rasam',
    explanation: 'Spiced tamarind soup. Light, anti-inflammatory, supports digestion and skin health.',
    acneImpactScore: 28,
    restaurantName: 'Indian Restaurant',
  },
];

// Flavors Of Namasthe India - specific menu with actual menu items
const FLAVORS_OF_NAMASTHE_INDIA_MENU: RestaurantMenuItem[] = [
  {
    name: 'Dal Tadka',
    explanation: 'Lentil curry with minimal oil, tempered with spices. High in protein and fiber, lower in dairy and oil than paneer dishes.',
    acneImpactScore: 35,
    restaurantName: 'Flavors Of Namasthe India',
  },
  {
    name: 'Tandoori Chicken',
    explanation: 'Grilled chicken marinated in yogurt and spices, cooked in tandoor. No deep-frying, lower in oil and dairy than creamy curries.',
    acneImpactScore: 38,
    restaurantName: 'Flavors Of Namasthe India',
  },
  {
    name: 'Herb-grilled chicken breast',
    explanation: 'Herb-grilled chicken breast with spices. No deep-frying, lower in oil than fried chicken dishes.',
    acneImpactScore: 38,
    restaurantName: 'Flavors Of Namasthe India',
  },
  {
    name: 'Fish Tikka',
    explanation: 'Grilled fish marinated in spices, cooked in tandoor. High in omega-3s, no deep-frying, excellent for skin health.',
    acneImpactScore: 35,
    restaurantName: 'Flavors Of Namasthe India',
  },
  {
    name: 'Chana Masala',
    explanation: 'Chickpea curry with tomatoes and spices. High in fiber, lower in dairy and oil than paneer dishes.',
    acneImpactScore: 40,
    restaurantName: 'Flavors Of Namasthe India',
  },
  {
    name: 'Bhindi Masala',
    explanation: 'Okra curry with minimal oil. High in fiber, no dairy, better for skin health.',
    acneImpactScore: 32,
    restaurantName: 'Flavors Of Namasthe India',
  },
  {
    name: 'Aloo Gobi',
    explanation: 'Potato and cauliflower curry with minimal oil. High in fiber, lower in dairy than creamy dishes.',
    acneImpactScore: 38,
    restaurantName: 'Flavors Of Namasthe India',
  },
  {
    name: 'Baingan Bharta',
    explanation: 'Roasted eggplant curry. High in fiber, minimal oil, no dairy, excellent for skin health.',
    acneImpactScore: 35,
    restaurantName: 'Flavors Of Namasthe India',
  },
  {
    name: 'Rajma',
    explanation: 'Kidney bean curry with tomatoes and spices. High in protein and fiber, lower in dairy and oil.',
    acneImpactScore: 38,
    restaurantName: 'Flavors Of Namasthe India',
  },
  {
    name: 'Tandoori Roti',
    explanation: 'Whole wheat flatbread cooked in tandoor. Lower in refined carbs and oil than naan.',
    acneImpactScore: 40,
    restaurantName: 'Flavors Of Namasthe India',
  },
  {
    name: 'Mixed Vegetable Curry',
    explanation: 'Vegetable-based curry with minimal oil. High in fiber, lower in dairy and refined carbs.',
    acneImpactScore: 38,
    restaurantName: 'Flavors Of Namasthe India',
  },
  {
    name: 'Dal Makhani (Light)',
    explanation: 'Black lentil curry, request light cream. High in protein and fiber, lower in dairy than regular version.',
    acneImpactScore: 42,
    restaurantName: 'Flavors Of Namasthe India',
  },
  {
    name: 'Tandoori Fish',
    explanation: 'Grilled fish marinated in spices, cooked in tandoor. High in omega-3s, no deep-frying, excellent for skin.',
    acneImpactScore: 35,
    restaurantName: 'Flavors Of Namasthe India',
  },
  {
    name: 'Vegetable Biryani (Light)',
    explanation: 'Vegetable biryani with minimal oil. Request light oil preparation. High in fiber, lower in oil than regular biryani.',
    acneImpactScore: 42,
    restaurantName: 'Flavors Of Namasthe India',
  },
  {
    name: 'Sambar',
    explanation: 'Lentil and vegetable stew. High in protein, fiber, and antioxidants. Supports skin health.',
    acneImpactScore: 33,
    restaurantName: 'Flavors Of Namasthe India',
  },
  {
    name: 'Rasam',
    explanation: 'Spiced tamarind soup. Light, anti-inflammatory, supports digestion and skin health.',
    acneImpactScore: 28,
    restaurantName: 'Flavors Of Namasthe India',
  },
  {
    name: 'Chicken Tikka Masala (Light)',
    explanation: 'Grilled chicken in tomato-based curry, request light cream. Lower in dairy than regular version.',
    acneImpactScore: 42,
    restaurantName: 'Flavors Of Namasthe India',
  },
  {
    name: 'Palak Paneer (Light)',
    explanation: 'Spinach curry with paneer, request light cream. High in iron and protein, lower in dairy than regular version.',
    acneImpactScore: 40,
    restaurantName: 'Flavors Of Namasthe India',
  },
  {
    name: 'Vegetable Korma (Light)',
    explanation: 'Mixed vegetables in mild curry, request light cream. Lower in dairy than regular version.',
    acneImpactScore: 40,
    restaurantName: 'Flavors Of Namasthe India',
  },
];

// American Tavern/Restaurant menu items (generic for taverns, pubs, casual dining)
const AMERICAN_TAVERN_MENU: RestaurantMenuItem[] = [
  {
    name: 'Pan-Seared Salmon',
    explanation: 'Fresh salmon fillet pan-seared to perfection, served with seasonal vegetables and a light citrus-herb sauce. High in omega-3s, no deep-frying, excellent for skin.',
    acneImpactScore: 35,
    restaurantName: 'American Tavern',
  },
  {
    name: 'Herb-grilled chicken breast',
    explanation: 'Herb-grilled chicken breast with garlic mashed potatoes and roasted vegetables. Lower in oil and processed fats than fried items.',
    acneImpactScore: 38,
    restaurantName: 'American Tavern',
  },
  {
    name: 'Grilled Chicken Caesar Salad',
    explanation: 'Caesar salad with grilled chicken. Lower in refined carbs and processed fats than burgers and fries.',
    acneImpactScore: 38,
    restaurantName: 'American Tavern',
  },
  {
    name: 'Grilled Salmon Salad',
    explanation: 'Fresh mixed greens with pan-seared salmon, seasonal vegetables, and light vinaigrette. High in omega-3s, lower in refined carbs.',
    acneImpactScore: 35,
    restaurantName: 'American Tavern',
  },
  {
    name: 'Pan-Seared White Fish',
    explanation: 'Pan-seared white fish with seasonal vegetables and lemon butter sauce. High in protein, lower in oil than fried items.',
    acneImpactScore: 35,
    restaurantName: 'American Tavern',
  },
  {
    name: 'Grilled Chicken Sandwich',
    explanation: 'Grilled chicken sandwich on whole grain bread with vegetables. Lower in processed fats than burgers.',
    acneImpactScore: 42,
    restaurantName: 'American Tavern',
  },
  {
    name: 'Garden Fresh Salad with Grilled Chicken',
    explanation: 'Fresh garden salad with grilled chicken, seasonal vegetables, and light dressing. High in fiber, lower in refined carbs.',
    acneImpactScore: 35,
    restaurantName: 'American Tavern',
  },
];

// Additional major restaurant chains
const DOMINOS_MENU: RestaurantMenuItem[] = [
  { name: 'Thin Crust Veggie Pizza', explanation: 'Thin crust with vegetables. Lower in refined carbs than thick crust.', acneImpactScore: 45, restaurantName: 'Domino\'s' },
  { name: 'Grilled Chicken Sandwich', explanation: 'Grilled chicken instead of fried. Lower in processed fats.', acneImpactScore: 42, restaurantName: 'Domino\'s' },
  { name: 'Garden Salad', explanation: 'Fresh vegetables. High in fiber, low in processed ingredients.', acneImpactScore: 30, restaurantName: 'Domino\'s' },
  { name: 'Chicken Caesar Salad', explanation: 'Salad with grilled chicken. Lower in refined carbs than pizza.', acneImpactScore: 38, restaurantName: 'Domino\'s' },
];

const PIZZA_HUT_MENU: RestaurantMenuItem[] = [
  { name: 'Thin \'N Crispy Veggie Pizza', explanation: 'Thin crust with vegetables. Lower in refined carbs.', acneImpactScore: 45, restaurantName: 'Pizza Hut' },
  { name: 'Grilled Chicken Salad', explanation: 'Salad with grilled chicken. Lower in processed fats than pizza.', acneImpactScore: 38, restaurantName: 'Pizza Hut' },
  { name: 'Garden Salad', explanation: 'Fresh vegetables. High in fiber, excellent for skin health.', acneImpactScore: 30, restaurantName: 'Pizza Hut' },
];

const LITTLE_CAESARS_MENU: RestaurantMenuItem[] = [
  { name: 'Thin Crust Veggie Pizza', explanation: 'Thin crust with vegetables. Lower in refined carbs.', acneImpactScore: 45, restaurantName: 'Little Caesars' },
  { name: 'Caesar Salad', explanation: 'Fresh greens. Lower in processed ingredients than pizza.', acneImpactScore: 35, restaurantName: 'Little Caesars' },
];

const PANERA_BREAD_MENU: RestaurantMenuItem[] = [
  { name: 'Mediterranean Veggie Sandwich', explanation: 'Vegetables on whole grain. High in fiber, lower in processed fats.', acneImpactScore: 38, restaurantName: 'Panera Bread' },
  { name: 'Grilled Chicken Caesar Salad', explanation: 'Salad with grilled chicken. Lower in refined carbs.', acneImpactScore: 35, restaurantName: 'Panera Bread' },
  { name: 'Green Goddess Cobb Salad', explanation: 'Fresh greens with vegetables. High in fiber.', acneImpactScore: 32, restaurantName: 'Panera Bread' },
  { name: 'Turkey Avocado BLT', explanation: 'Turkey with avocado and vegetables. Lower in processed fats.', acneImpactScore: 40, restaurantName: 'Panera Bread' },
  { name: 'Chicken Noodle Soup', explanation: 'Soup with vegetables. Lower in refined carbs than sandwiches.', acneImpactScore: 35, restaurantName: 'Panera Bread' },
  { name: 'Mediterranean Bowl', explanation: 'Vegetables and grains. High in fiber, lower in processed ingredients.', acneImpactScore: 32, restaurantName: 'Panera Bread' },
];

const STARBUCKS_MENU: RestaurantMenuItem[] = [
  { name: 'Spinach, Feta & Cage-Free Egg White Wrap', explanation: 'Egg whites with vegetables. Lower in refined carbs than pastries.', acneImpactScore: 38, restaurantName: 'Starbucks' },
  { name: 'Chicken & Quinoa Protein Bowl', explanation: 'Quinoa with chicken and vegetables. High in fiber and protein.', acneImpactScore: 35, restaurantName: 'Starbucks' },
  { name: 'Egg White & Roasted Red Pepper Sous Vide Egg Bites', explanation: 'Egg whites with vegetables. Lower in processed fats.', acneImpactScore: 40, restaurantName: 'Starbucks' },
  { name: 'Chicken & Hummus Protein Box', explanation: 'Chicken with hummus and vegetables. Lower in refined carbs.', acneImpactScore: 38, restaurantName: 'Starbucks' },
  { name: 'Oatmeal', explanation: 'Whole grain oatmeal. High in fiber, lower in refined carbs.', acneImpactScore: 35, restaurantName: 'Starbucks' },
];

const JIMMY_JOHNS_MENU: RestaurantMenuItem[] = [
  { name: 'Turkey Tom Unwich', explanation: 'Turkey with vegetables, no bread. Lower in refined carbs.', acneImpactScore: 35, restaurantName: 'Jimmy John\'s' },
  { name: 'Veggie Unwich', explanation: 'Vegetables, no bread. High in fiber, lower in refined carbs.', acneImpactScore: 30, restaurantName: 'Jimmy John\'s' },
  { name: 'Turkey Tom on Wheat', explanation: 'Turkey on whole wheat. Lower in refined carbs than white bread.', acneImpactScore: 40, restaurantName: 'Jimmy John\'s' },
  { name: 'Veggie on Wheat', explanation: 'Vegetables on whole wheat. High in fiber.', acneImpactScore: 38, restaurantName: 'Jimmy John\'s' },
];

const ARBYS_MENU: RestaurantMenuItem[] = [
  { name: 'Roast Turkey & Swiss Wrap', explanation: 'Turkey wrap with vegetables. Lower in processed fats than roast beef.', acneImpactScore: 42, restaurantName: 'Arby\'s' },
  { name: 'Grilled Chicken Salad', explanation: 'Salad with grilled chicken. Lower in refined carbs than sandwiches.', acneImpactScore: 35, restaurantName: 'Arby\'s' },
  { name: 'Roast Turkey Ranch & Bacon Sandwich', explanation: 'Turkey sandwich. Lower in processed fats than roast beef.', acneImpactScore: 45, restaurantName: 'Arby\'s' },
];

const SONIC_MENU: RestaurantMenuItem[] = [
  { name: 'Grilled Chicken Sandwich', explanation: 'Grilled chicken instead of fried. Lower in processed fats.', acneImpactScore: 42, restaurantName: 'Sonic' },
  { name: 'Grilled Chicken Wrap', explanation: 'Grilled chicken with vegetables. Lower in refined carbs.', acneImpactScore: 40, restaurantName: 'Sonic' },
  { name: 'Grilled Chicken Salad', explanation: 'Salad with grilled chicken. Lower in processed ingredients.', acneImpactScore: 35, restaurantName: 'Sonic' },
];

const JACK_IN_THE_BOX_MENU: RestaurantMenuItem[] = [
  { name: 'Grilled Chicken Salad', explanation: 'Salad with grilled chicken. Lower in refined carbs than burgers.', acneImpactScore: 35, restaurantName: 'Jack in the Box' },
  { name: 'Grilled Chicken Sandwich', explanation: 'Grilled chicken instead of fried. Lower in processed fats.', acneImpactScore: 42, restaurantName: 'Jack in the Box' },
  { name: 'Chicken Fajita Pita', explanation: 'Chicken with vegetables. Lower in refined carbs than burgers.', acneImpactScore: 40, restaurantName: 'Jack in the Box' },
];

const CARLS_JR_MENU: RestaurantMenuItem[] = [
  { name: 'Charbroiled BBQ Chicken Sandwich', explanation: 'Grilled chicken instead of fried. Lower in processed fats.', acneImpactScore: 42, restaurantName: 'Carl\'s Jr.' },
  { name: 'Charbroiled Chicken Salad', explanation: 'Salad with grilled chicken. Lower in refined carbs.', acneImpactScore: 35, restaurantName: 'Carl\'s Jr.' },
  { name: 'Charbroiled Chicken Club Sandwich', explanation: 'Grilled chicken with vegetables. Lower in processed fats.', acneImpactScore: 45, restaurantName: 'Carl\'s Jr.' },
];

const HARDEE_MENU: RestaurantMenuItem[] = [
  { name: 'Charbroiled Chicken Sandwich', explanation: 'Grilled chicken instead of fried. Lower in processed fats.', acneImpactScore: 42, restaurantName: 'Hardee\'s' },
  { name: 'Charbroiled Chicken Salad', explanation: 'Salad with grilled chicken. Lower in refined carbs.', acneImpactScore: 35, restaurantName: 'Hardee\'s' },
];

const FIVE_GUYS_MENU: RestaurantMenuItem[] = [
  { name: 'Bacon Cheeseburger (no bun)', explanation: 'Burger without bun. Lower in refined carbs.', acneImpactScore: 48, restaurantName: 'Five Guys' },
  { name: 'Veggie Sandwich', explanation: 'Vegetables on bun. Lower in processed fats than burgers.', acneImpactScore: 42, restaurantName: 'Five Guys' },
  { name: 'Grilled Cheese', explanation: 'Cheese sandwich. Lower in processed fats than burgers.', acneImpactScore: 45, restaurantName: 'Five Guys' },
];

const SHAKE_SHACK_MENU: RestaurantMenuItem[] = [
  { name: 'ShackBurger (no bun)', explanation: 'Burger without bun. Lower in refined carbs.', acneImpactScore: 50, restaurantName: 'Shake Shack' },
  { name: 'Shroom Burger (no bun)', explanation: 'Mushroom burger without bun. Lower in refined carbs.', acneImpactScore: 48, restaurantName: 'Shake Shack' },
  { name: 'Chicken Shack (no bun)', explanation: 'Chicken burger without bun. Lower in refined carbs.', acneImpactScore: 45, restaurantName: 'Shake Shack' },
];

const IN_N_OUT_MENU: RestaurantMenuItem[] = [
  { name: 'Hamburger (no bun)', explanation: 'Burger without bun. Lower in refined carbs.', acneImpactScore: 50, restaurantName: 'In-N-Out' },
  { name: 'Cheeseburger (no bun)', explanation: 'Burger without bun. Lower in refined carbs.', acneImpactScore: 52, restaurantName: 'In-N-Out' },
  { name: 'Protein Style Burger', explanation: 'Burger wrapped in lettuce instead of bun. Lower in refined carbs.', acneImpactScore: 45, restaurantName: 'In-N-Out' },
];

const CHICK_FIL_A_MENU: RestaurantMenuItem[] = [
  { name: 'Grilled Chicken Sandwich', explanation: 'Grilled chicken instead of fried. Much lower in processed fats.', acneImpactScore: 38, restaurantName: 'Chick-fil-A' },
  { name: 'Grilled Chicken Club Sandwich', explanation: 'Grilled chicken with vegetables. Lower in processed fats.', acneImpactScore: 40, restaurantName: 'Chick-fil-A' },
  { name: 'Grilled Nuggets', explanation: 'Grilled chicken nuggets. Much lower in processed fats than fried.', acneImpactScore: 35, restaurantName: 'Chick-fil-A' },
  { name: 'Grilled Chicken Cool Wrap', explanation: 'Grilled chicken wrap with vegetables. Lower in refined carbs.', acneImpactScore: 38, restaurantName: 'Chick-fil-A' },
  { name: 'Market Salad', explanation: 'Salad with grilled chicken. Lower in refined carbs.', acneImpactScore: 32, restaurantName: 'Chick-fil-A' },
  { name: 'Spicy Southwest Salad', explanation: 'Salad with grilled chicken. Lower in refined carbs.', acneImpactScore: 35, restaurantName: 'Chick-fil-A' },
];

const POPEYES_MENU: RestaurantMenuItem[] = [
  { name: 'Blackened Chicken Sandwich', explanation: 'Blackened chicken instead of fried. Lower in processed fats.', acneImpactScore: 42, restaurantName: 'Popeyes' },
  { name: 'Blackened Chicken Tenders', explanation: 'Blackened chicken instead of fried. Lower in processed fats.', acneImpactScore: 40, restaurantName: 'Popeyes' },
];

const WINGSTOP_MENU: RestaurantMenuItem[] = [
  { name: 'Boneless Wings (Grilled)', explanation: 'Grilled wings instead of fried. Lower in processed fats.', acneImpactScore: 45, restaurantName: 'Wingstop' },
  { name: 'Veggie Sticks', explanation: 'Vegetable sticks. High in fiber, lower in processed ingredients.', acneImpactScore: 30, restaurantName: 'Wingstop' },
];

const BUFFALO_WILD_WINGS_MENU: RestaurantMenuItem[] = [
  { name: 'Grilled Chicken Breast', explanation: 'Grilled chicken instead of fried wings. Lower in processed fats.', acneImpactScore: 40, restaurantName: 'Buffalo Wild Wings' },
  { name: 'Grilled Chicken Salad', explanation: 'Salad with grilled chicken. Lower in refined carbs.', acneImpactScore: 35, restaurantName: 'Buffalo Wild Wings' },
  { name: 'Grilled Chicken Wrap', explanation: 'Grilled chicken with vegetables. Lower in refined carbs.', acneImpactScore: 38, restaurantName: 'Buffalo Wild Wings' },
];

const DENNYS_MENU: RestaurantMenuItem[] = [
  { name: 'Fit Slam', explanation: 'Egg whites, turkey bacon, and fruit. Lower in processed fats.', acneImpactScore: 38, restaurantName: 'Denny\'s' },
  { name: 'Grilled Chicken Salad', explanation: 'Salad with grilled chicken. Lower in refined carbs.', acneImpactScore: 35, restaurantName: 'Denny\'s' },
  { name: 'Fit Fare Veggie Skillet', explanation: 'Vegetables with eggs. Lower in refined carbs.', acneImpactScore: 32, restaurantName: 'Denny\'s' },
  { name: 'Grilled Chicken Breast', explanation: 'Grilled chicken with vegetables. Lower in processed fats.', acneImpactScore: 38, restaurantName: 'Denny\'s' },
];

const IHOP_MENU: RestaurantMenuItem[] = [
  { name: 'Simple & Fit Veggie Omelette', explanation: 'Egg whites with vegetables. Lower in processed fats.', acneImpactScore: 35, restaurantName: 'IHOP' },
  { name: 'Simple & Fit Chicken & Veggie Salad', explanation: 'Salad with grilled chicken. Lower in refined carbs.', acneImpactScore: 32, restaurantName: 'IHOP' },
  { name: 'Simple & Fit Grilled Chicken', explanation: 'Grilled chicken with vegetables. Lower in processed fats.', acneImpactScore: 38, restaurantName: 'IHOP' },
];

const WAFFLE_HOUSE_MENU: RestaurantMenuItem[] = [
  { name: 'Grilled Chicken Breast', explanation: 'Grilled chicken instead of fried. Lower in processed fats.', acneImpactScore: 40, restaurantName: 'Waffle House' },
  { name: 'Grilled Chicken Salad', explanation: 'Salad with grilled chicken. Lower in refined carbs.', acneImpactScore: 35, restaurantName: 'Waffle House' },
];

const TGI_FRIDAYS_MENU: RestaurantMenuItem[] = [
  { name: 'Grilled Chicken Salad', explanation: 'Salad with grilled chicken. Lower in refined carbs.', acneImpactScore: 35, restaurantName: 'TGI Friday\'s' },
  { name: 'Grilled Salmon', explanation: 'Grilled salmon with vegetables. High in omega-3s, lower in processed fats.', acneImpactScore: 32, restaurantName: 'TGI Friday\'s' },
  { name: 'Grilled Chicken Breast', explanation: 'Grilled chicken with vegetables. Lower in processed fats.', acneImpactScore: 38, restaurantName: 'TGI Friday\'s' },
];

const CHILIS_MENU: RestaurantMenuItem[] = [
  { name: 'Grilled Chicken Salad', explanation: 'Salad with grilled chicken. Lower in refined carbs.', acneImpactScore: 35, restaurantName: 'Chili\'s' },
  { name: 'Grilled Salmon', explanation: 'Grilled salmon with vegetables. High in omega-3s.', acneImpactScore: 32, restaurantName: 'Chili\'s' },
  { name: 'Grilled Chicken Breast', explanation: 'Grilled chicken with vegetables. Lower in processed fats.', acneImpactScore: 38, restaurantName: 'Chili\'s' },
  { name: 'Grilled Chicken Sandwich', explanation: 'Grilled chicken instead of fried. Lower in processed fats.', acneImpactScore: 42, restaurantName: 'Chili\'s' },
];

const RUBY_TUESDAY_MENU: RestaurantMenuItem[] = [
  { name: 'Grilled Chicken Salad', explanation: 'Salad with grilled chicken. Lower in refined carbs.', acneImpactScore: 35, restaurantName: 'Ruby Tuesday' },
  { name: 'Grilled Salmon', explanation: 'Grilled salmon with vegetables. High in omega-3s.', acneImpactScore: 32, restaurantName: 'Ruby Tuesday' },
  { name: 'Grilled Chicken Breast', explanation: 'Grilled chicken with vegetables. Lower in processed fats.', acneImpactScore: 38, restaurantName: 'Ruby Tuesday' },
];

const TEXAS_ROADHOUSE_MENU: RestaurantMenuItem[] = [
  { name: 'Grilled Chicken Salad', explanation: 'Salad with grilled chicken. Lower in refined carbs.', acneImpactScore: 35, restaurantName: 'Texas Roadhouse' },
  { name: 'Grilled Salmon', explanation: 'Grilled salmon with vegetables. High in omega-3s.', acneImpactScore: 32, restaurantName: 'Texas Roadhouse' },
  { name: 'Grilled Chicken Breast', explanation: 'Grilled chicken with vegetables. Lower in processed fats.', acneImpactScore: 38, restaurantName: 'Texas Roadhouse' },
  { name: 'Sirloin Steak (6 oz)', explanation: 'Grilled steak with vegetables. Lower in processed fats than fried items.', acneImpactScore: 42, restaurantName: 'Texas Roadhouse' },
];

const LONGHORN_STEAKHOUSE_MENU: RestaurantMenuItem[] = [
  { name: 'Grilled Chicken Salad', explanation: 'Salad with grilled chicken. Lower in refined carbs.', acneImpactScore: 35, restaurantName: 'LongHorn Steakhouse' },
  { name: 'Grilled Salmon', explanation: 'Grilled salmon with vegetables. High in omega-3s.', acneImpactScore: 32, restaurantName: 'LongHorn Steakhouse' },
  { name: 'Grilled Chicken Breast', explanation: 'Grilled chicken with vegetables. Lower in processed fats.', acneImpactScore: 38, restaurantName: 'LongHorn Steakhouse' },
  { name: 'Flo\'s Filet (6 oz)', explanation: 'Grilled steak with vegetables. Lower in processed fats.', acneImpactScore: 40, restaurantName: 'LongHorn Steakhouse' },
];

const BONEFISH_GRILL_MENU: RestaurantMenuItem[] = [
  { name: 'Grilled Salmon', explanation: 'Grilled salmon with vegetables. High in omega-3s, excellent for skin.', acneImpactScore: 30, restaurantName: 'Bonefish Grill' },
  { name: 'Grilled Mahi Mahi', explanation: 'Grilled fish with vegetables. High in protein, lower in processed fats.', acneImpactScore: 32, restaurantName: 'Bonefish Grill' },
  { name: 'Grilled Chicken Breast', explanation: 'Grilled chicken with vegetables. Lower in processed fats.', acneImpactScore: 38, restaurantName: 'Bonefish Grill' },
  { name: 'Ahi Tuna Steak', explanation: 'Grilled tuna with vegetables. High in omega-3s.', acneImpactScore: 30, restaurantName: 'Bonefish Grill' },
];

const BJS_RESTAURANT_MENU: RestaurantMenuItem[] = [
  { name: 'Grilled Chicken Salad', explanation: 'Salad with grilled chicken. Lower in refined carbs.', acneImpactScore: 35, restaurantName: 'BJ\'s Restaurant' },
  { name: 'Grilled Salmon', explanation: 'Grilled salmon with vegetables. High in omega-3s.', acneImpactScore: 32, restaurantName: 'BJ\'s Restaurant' },
  { name: 'Grilled Chicken Breast', explanation: 'Grilled chicken with vegetables. Lower in processed fats.', acneImpactScore: 38, restaurantName: 'BJ\'s Restaurant' },
];

const CALIFORNIA_PIZZA_KITCHEN_MENU: RestaurantMenuItem[] = [
  { name: 'Thai Crunch Salad', explanation: 'Salad with vegetables. Lower in refined carbs than pizza.', acneImpactScore: 32, restaurantName: 'California Pizza Kitchen' },
  { name: 'Grilled Chicken Salad', explanation: 'Salad with grilled chicken. Lower in refined carbs.', acneImpactScore: 35, restaurantName: 'California Pizza Kitchen' },
  { name: 'Grilled Salmon', explanation: 'Grilled salmon with vegetables. High in omega-3s.', acneImpactScore: 32, restaurantName: 'California Pizza Kitchen' },
  { name: 'Thin Crust Veggie Pizza', explanation: 'Thin crust with vegetables. Lower in refined carbs than thick crust.', acneImpactScore: 45, restaurantName: 'California Pizza Kitchen' },
];

const PF_CHANGS_MENU: RestaurantMenuItem[] = [
  { name: 'Steamed Buddha\'s Feast', explanation: 'Steamed vegetables. High in fiber, no oil, excellent for skin.', acneImpactScore: 25, restaurantName: 'P.F. Chang\'s' },
  { name: 'Grilled Salmon', explanation: 'Grilled salmon with vegetables. High in omega-3s, lower in processed fats.', acneImpactScore: 30, restaurantName: 'P.F. Chang\'s' },
  { name: 'Mongolian Beef (steamed)', explanation: 'Beef with vegetables, steamed instead of fried. Lower in oil.', acneImpactScore: 42, restaurantName: 'P.F. Chang\'s' },
  { name: 'Chang\'s Chicken Lettuce Wraps', explanation: 'Chicken with vegetables in lettuce. Lower in refined carbs.', acneImpactScore: 35, restaurantName: 'P.F. Chang\'s' },
  { name: 'Steamed Brown Rice', explanation: 'Whole grain rice. High in fiber, lower in refined carbs.', acneImpactScore: 30, restaurantName: 'P.F. Chang\'s' },
  { name: 'Steamed Vegetables', explanation: 'Steamed vegetables. High in fiber, no oil.', acneImpactScore: 20, restaurantName: 'P.F. Chang\'s' },
];

const BENIHANA_MENU: RestaurantMenuItem[] = [
  { name: 'Grilled Chicken', explanation: 'Grilled chicken with vegetables. Lower in processed fats.', acneImpactScore: 38, restaurantName: 'Benihana' },
  { name: 'Grilled Salmon', explanation: 'Grilled salmon with vegetables. High in omega-3s.', acneImpactScore: 32, restaurantName: 'Benihana' },
  { name: 'Grilled Steak', explanation: 'Grilled steak with vegetables. Lower in processed fats.', acneImpactScore: 42, restaurantName: 'Benihana' },
  { name: 'Steamed Rice', explanation: 'Steamed rice. Lower in refined carbs than fried rice.', acneImpactScore: 35, restaurantName: 'Benihana' },
];

// Restaurant menu database
const RESTAURANT_MENUS: Record<string, RestaurantMenuItem[]> = {
  'cheesecake factory': CHEESECAKE_FACTORY_MENU,
  'the cheesecake factory': CHEESECAKE_FACTORY_MENU,
  'mcdonald\'s': MCDONALDS_MENU,
  'mcdonalds': MCDONALDS_MENU,
  'dunkin\' donuts': DUNKIN_DONUTS_MENU,
  'dunkin donuts': DUNKIN_DONUTS_MENU,
  'dunkin': DUNKIN_DONUTS_MENU,
  'wendy\'s': WENDYS_MENU,
  'wendys': WENDYS_MENU,
  'burger king': BURGER_KING_MENU,
  'subway': SUBWAY_MENU,
  'kfc': KFC_MENU,
  'taco bell': TACO_BELL_MENU,
  'chipotle': CHIPOTLE_MENU,
  'olive garden': OLIVE_GARDEN_MENU,
  'applebee\'s': APPLEBEES_MENU,
  'applebees': APPLEBEES_MENU,
  'outback': OUTBACK_MENU,
  'outback steakhouse': OUTBACK_MENU,
  'red lobster': RED_LOBSTER_MENU,
  'panda express': PANDA_EXPRESS_MENU,
  // Specific restaurants with exact menus only (no generic/template menus)
  'flavors of namasthe india': FLAVORS_OF_NAMASTHE_INDIA_MENU,
  'flavors of namasthe': FLAVORS_OF_NAMASTHE_INDIA_MENU,
  'namasthe india': FLAVORS_OF_NAMASTHE_INDIA_MENU,
  'namasthe': FLAVORS_OF_NAMASTHE_INDIA_MENU,
  // American taverns - only specific restaurants with exact menus
  'topside tavern': AMERICAN_TAVERN_MENU,
  'topside': AMERICAN_TAVERN_MENU,
  // Pizza chains
  'domino\'s': DOMINOS_MENU,
  'dominos': DOMINOS_MENU,
  'domino\'s pizza': DOMINOS_MENU,
  'pizza hut': PIZZA_HUT_MENU,
  'little caesars': LITTLE_CAESARS_MENU,
  'little caesar': LITTLE_CAESARS_MENU,
  // Fast casual
  'panera bread': PANERA_BREAD_MENU,
  'panera': PANERA_BREAD_MENU,
  'starbucks': STARBUCKS_MENU,
  'jimmy john\'s': JIMMY_JOHNS_MENU,
  'jimmy johns': JIMMY_JOHNS_MENU,
  // Fast food
  'arbys': ARBYS_MENU,
  'sonic': SONIC_MENU,
  'sonic drive-in': SONIC_MENU,
  'jack in the box': JACK_IN_THE_BOX_MENU,
  'carl\'s jr': CARLS_JR_MENU,
  'carls jr': CARLS_JR_MENU,
  'hardee\'s': HARDEE_MENU,
  'hardees': HARDEE_MENU,
  'five guys': FIVE_GUYS_MENU,
  'five guys burgers and fries': FIVE_GUYS_MENU,
  'shake shack': SHAKE_SHACK_MENU,
  'in-n-out': IN_N_OUT_MENU,
  'in n out': IN_N_OUT_MENU,
  'in and out': IN_N_OUT_MENU,
  'chick-fil-a': CHICK_FIL_A_MENU,
  'chick fil a': CHICK_FIL_A_MENU,
  'chickfila': CHICK_FIL_A_MENU,
  'popeyes': POPEYES_MENU,
  'popeyes louisiana kitchen': POPEYES_MENU,
  'wingstop': WINGSTOP_MENU,
  'buffalo wild wings': BUFFALO_WILD_WINGS_MENU,
  'bww': BUFFALO_WILD_WINGS_MENU,
  // Breakfast chains
  'denny\'s': DENNYS_MENU,
  'dennys': DENNYS_MENU,
  'ihop': IHOP_MENU,
  'international house of pancakes': IHOP_MENU,
  'waffle house': WAFFLE_HOUSE_MENU,
  // Casual dining
  'tgi friday\'s': TGI_FRIDAYS_MENU,
  'tgi fridays': TGI_FRIDAYS_MENU,
  'fridays': TGI_FRIDAYS_MENU,
  'chili\'s': CHILIS_MENU,
  'chilis': CHILIS_MENU,
  'ruby tuesday': RUBY_TUESDAY_MENU,
  'texas roadhouse': TEXAS_ROADHOUSE_MENU,
  'longhorn steakhouse': LONGHORN_STEAKHOUSE_MENU,
  'longhorn': LONGHORN_STEAKHOUSE_MENU,
  'bonefish grill': BONEFISH_GRILL_MENU,
  'bjs restaurant': BJS_RESTAURANT_MENU,
  'bjs': BJS_RESTAURANT_MENU,
  'california pizza kitchen': CALIFORNIA_PIZZA_KITCHEN_MENU,
  'cpk': CALIFORNIA_PIZZA_KITCHEN_MENU,
  'p.f. chang\'s': PF_CHANGS_MENU,
  'pf chang\'s': PF_CHANGS_MENU,
  'pf changs': PF_CHANGS_MENU,
  'pfchang': PF_CHANGS_MENU,
  'benihana': BENIHANA_MENU,
  // Note: Removed all generic/template restaurant entries (e.g., 'indian restaurant', 'tavern', 'pub', etc.)
  // Only restaurants with specific menus are included. All others will return empty array.
};

/**
 * Calculate Levenshtein distance between two strings (for fuzzy matching)
 */
function levenshteinDistance(str1: string, str2: string): number {
  const matrix: number[][] = [];
  const len1 = str1.length;
  const len2 = str2.length;

  if (len1 === 0) return len2;
  if (len2 === 0) return len1;

  for (let i = 0; i <= len2; i++) {
    matrix[i] = [i];
  }

  for (let j = 0; j <= len1; j++) {
    matrix[0][j] = j;
  }

  for (let i = 1; i <= len2; i++) {
    for (let j = 1; j <= len1; j++) {
      if (str2.charAt(i - 1) === str1.charAt(j - 1)) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j] + 1
        );
      }
    }
  }

  return matrix[len2][len1];
}

/**
 * Fuzzy match restaurant name against known restaurants
 * Returns the best matching restaurant name or null
 */
export function fuzzyMatchRestaurantName(inputName: string): string | null {
  const lowerInput = inputName.toLowerCase().trim();
  const knownRestaurants = Object.keys(RESTAURANT_MENUS);
  
  // Remove common words that don't affect matching
  const removeCommonWords = (str: string) => {
    return str
      .replace(/\b(the|a|an|and|or|of|at|in|on)\b/gi, '')
      .replace(/\s+/g, ' ')
      .trim();
  };
  
  const normalizedInput = removeCommonWords(lowerInput);
  
  // First, try exact match
  if (RESTAURANT_MENUS[lowerInput]) {
    return lowerInput;
  }
  
  // Try partial match (input contains restaurant name or vice versa)
  for (const knownName of knownRestaurants) {
    const normalizedKnown = removeCommonWords(knownName);
    if (normalizedInput.includes(normalizedKnown) || normalizedKnown.includes(normalizedInput)) {
      return knownName;
    }
  }
  
  // Try fuzzy match using Levenshtein distance
  let bestMatch: string | null = null;
  let bestScore = Infinity;
  const maxDistance = Math.max(3, Math.floor(inputName.length * 0.3)); // Allow up to 30% of length as distance
  
  for (const knownName of knownRestaurants) {
    const distance = levenshteinDistance(normalizedInput, removeCommonWords(knownName));
    if (distance < bestScore && distance <= maxDistance) {
      bestScore = distance;
      bestMatch = knownName;
    }
  }
  
  return bestMatch;
}

/**
 * Get actual menu items for a specific restaurant
 * 
 * CRITICAL: This function ONLY returns menus for restaurants that have exact matches
 * in the RESTAURANT_MENUS database. It does NOT return template/generic menus.
 * 
 * If a restaurant is not found, it returns an empty array.
 */
export function getRestaurantMenuItems(restaurantName: string): RestaurantMenuItem[] {
  const lowerName = restaurantName.toLowerCase().trim();
  
  // Check exact match first
  if (RESTAURANT_MENUS[lowerName]) {
    return RESTAURANT_MENUS[lowerName];
  }
  
  // Try fuzzy matching for known restaurants (only for exact matches, not templates)
  const fuzzyMatched = fuzzyMatchRestaurantName(restaurantName);
  if (fuzzyMatched && RESTAURANT_MENUS[fuzzyMatched]) {
    return RESTAURANT_MENUS[fuzzyMatched];
  }
  
  // NO TEMPLATE/GENERIC MENUS - Only return exact matches
  // If restaurant is not in database, return empty array
  return [];
}

/**
 * Get cuisine type for a restaurant (for fallback)
 */
export function getRestaurantCuisine(restaurantName: string): string | null {
  const lowerName = restaurantName.toLowerCase().trim();
  
  if (RESTAURANT_MENUS[lowerName]) {
    // Return cuisine based on restaurant type
    if (lowerName.includes('mcdonald') || lowerName.includes('wendy') || lowerName.includes('burger king') || 
        lowerName.includes('subway') || lowerName.includes('kfc') || lowerName.includes('taco bell') ||
        lowerName.includes('dunkin')) {
      return 'american_fast_food';
    }
    if (lowerName.includes('cheesecake') || lowerName.includes('applebees') || lowerName.includes('outback') || 
        lowerName.includes('red lobster')) {
      return 'american_casual';
    }
    if (lowerName.includes('olive garden')) {
      return 'italian';
    }
    if (lowerName.includes('chipotle') || lowerName.includes('taco bell')) {
      return 'mexican';
    }
    if (lowerName.includes('panda express')) {
      return 'chinese';
    }
  }
  
  return null;
}

